import script from "./TeacherIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./TeacherIndex.vue?vue&type=script&setup=true&lang=js"

import "./TeacherIndex.vue?vue&type=style&index=0&id=012d3f75&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-012d3f75"]])

export default __exports__